import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getData } from "./data"
import { Filters } from "./Filters"
import Table from "./Table"
import axios from "axios"
import {API_URL, sitename} from "constants/constants"
import {FiltersCard} from "../../../components/Common/FiltersCard";
import moment from "moment";
const BonusTicketWinning = props => {
    const [item, setItem] = useState("All")
    const [loadingMessage, setLoadingMessage] = useState("1");
    const [toDate, setToDate] =useState(moment().format("YYYY-MM-DD"))
    const [fromDate, setFromDate] =useState(moment().format("YYYY-MM-DD"))
    const [data, setData] = useState([])
    useEffect(() => {
        call()
    }, [])
    const call = () => {
        axios({
            method: "get",
            url: `${API_URL}/admin/reports/bonus-ticket-winning-Report?to=${toDate}&from=${fromDate}&type=${item}`,
        })
            .then(function (response) {
                console.log(response?.data?.data)
                setData(response?.data?.data)
                // setData(response?.data?.data?.data)
                setLoadingMessage("0");
            })
            .catch(function (response) {
            })
    }
    const options = [
        { label: "Lost", value: "Lost" },
        { label: "Won", value: "Won" },
        { label: "All", value: "All" },
        { label: "Pending", value: "Pending" },
        { label: "Void", value: "Void" },
    ]


    return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Bonus Tickets  Report" />
        </Container>
          <FiltersCard
              item={item}
              setItem={setItem}
              options={options}
              fromDate={fromDate}
              toDate={toDate}
              setToDate={setToDate}
              setFromDate={setFromDate}
              showToDate={true}
              call={() => {
                  call()
              }}
              hideShowType={false}
          />
          <Table data={data}
                 call={() => {
                     call()
                 }}
                 loadingMessage={loadingMessage}
                 setLoadingMessage={setLoadingMessage}
          />
      </div>
    </React.Fragment>
  )
}
export default withRouter(BonusTicketWinning)
